if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer || !this.elements.thumbnails) return;

        /*
         * Update the active thumbnail immediately.
         * The previous debounce could leave the indicator behind.
         */
        this.elements.viewer.addEventListener(
          'slideChanged',
          this.onSlideChanged.bind(this)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');

            if (!button) return;

            button.addEventListener(
  'click',
  this.setActiveMedia.bind(
    this,
    mediaToSwitch.dataset.target,
    true
  )
);
          });

        if (
          this.dataset.desktopLayout?.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
        const initialActiveMedia =
  this.elements.viewer.querySelector(
    '[data-media-id].is-active'
  );

if (initialActiveMedia) {
  window.requestAnimationFrame(() => {
    this.setActiveMedia(
      initialActiveMedia.dataset.mediaId,
      false
    );
  });
}
      }

      onSlideChanged(event) {
        const currentMediaId =
          event.detail?.currentElement?.dataset?.mediaId;

        if (!currentMediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentMediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, shouldScrollPage = true) {
        /*
         * Only select the requested media.
         * Do not fall back to the first image and do not rearrange anything.
         */
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (shouldScrollPage) {
  this.preventStickyHeader();
}

        /*
         * Wait for Shopify and the browser to finish any variant updates,
         * then scroll to the correct image using its current position.
         */
        window.requestAnimationFrame(() => {
          const viewerSlider =
            this.elements.viewer.slider ||
            activeMedia.parentElement;

          if (viewerSlider) {
            const sliderRect = viewerSlider.getBoundingClientRect();
            const mediaRect = activeMedia.getBoundingClientRect();

            const targetLeft =
              viewerSlider.scrollLeft +
              mediaRect.left -
              sliderRect.left;

            viewerSlider.scrollTo({
              left: Math.max(0, targetLeft),
              behavior: 'instant',
            });
          }
/*
 * Size selections can update the selected variant
 * without moving the page away from the product form.
 */
if (!shouldScrollPage) return;
          const activeMediaRect =
            activeMedia.getBoundingClientRect();

          /*
           * Do not move the page vertically when the gallery
           * is already visible.
           */
          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        /*
         * Some variants may not have a matching thumbnail.
         * Avoid throwing an error that would break later interactions.
         */
        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        const thumbnailButton =
          thumbnail.querySelector('button');

        if (!thumbnailButton) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        thumbnailButton.setAttribute('aria-current', 'true');

        const thumbnailSlider =
          this.elements.thumbnails.slider;

        if (!thumbnailSlider) return;

        /*
         * Calculate visibility from the current screen positions.
         * This avoids stale measurements from the slider component.
         */
        const sliderRect =
          thumbnailSlider.getBoundingClientRect();

        const thumbnailRect =
          thumbnail.getBoundingClientRect();

        const edgeSpace = 8;

        const isVisible =
          thumbnailRect.left >= sliderRect.left + edgeSpace &&
          thumbnailRect.right <= sliderRect.right - edgeSpace;

        if (isVisible) return;

        const targetLeft =
          thumbnailSlider.scrollLeft +
          thumbnailRect.left -
          sliderRect.left -
          (thumbnailSlider.clientWidth - thumbnailRect.width) / 2;

        thumbnailSlider.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth',
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          window.setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}